var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricetag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.56049 5.4395C8.14649 6.0245 8.14649 6.9755 7.56049 7.5605C6.97449 8.1465 6.02549 8.1465 5.43949 7.5605C4.85349 6.9755 4.85349 6.0245 5.43949 5.4395C6.02549 4.8535 6.97449 4.8535 7.56049 5.4395ZM2.83399 9.89161L8.86599 15.9246L15.924 8.8666L9.89199 2.83361L2.10699 2.1076L2.83399 9.89161ZM8.86599 17.9986C8.40099 17.9986 7.93699 17.8216 7.58199 17.4686L1.16499 11.0506C0.999987 10.8866 0.897987 10.6686 0.875987 10.4366L0.00398718 1.0926C-0.0230128 0.796605 0.0819872 0.503605 0.292987 0.292605C0.503987 0.081605 0.795987 -0.025395 1.09299 0.00460499L10.437 0.876605C10.669 0.897605 10.886 0.999605 11.051 1.16461L17.468 7.5816C17.811 7.9246 18 8.3806 18 8.8666C18 9.3526 17.811 9.8086 17.468 10.1516L10.151 17.4676C9.79699 17.8216 9.33199 17.9986 8.86599 17.9986Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricetag);
export default __webpack_public_path__ + "static/media/pricetag.85c8fe72c7a4e07674299698f4e3922b.svg";
export { ForwardRef as ReactComponent };